// removed by extract-text-webpack-plugin
module.exports = {"container":"Highlighter__container___1nRsp","delete":"Highlighter__delete___PMuPT","edit":"Highlighter__edit___3HXTJ","focus":"Highlighter__focus___1j5ME","highlight":"Highlighter__highlight___1D6TX","label":"Highlighter__label___m2cnB"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/views/Highlighter.css
 ** module id = 708
 ** module chunks = 0
 **/